import { Divider, Grid, Pagination, Stack, Typography } from '@mui/material';
import moment from 'moment';
import { useMemo, useState } from 'react';
import { TailSpin } from 'react-loader-spinner';
import { adminAxiosInstance, axiosInstance } from 'src/api/axios';
import PageContainer from 'src/components/container/PageContainer';
import AdminFilterBox from '../dashboard/AdminFilterBox';
import AdminUsersTable from '../dashboard/components/AdminUsersTable';

const AdminUsers = () => {
  const [shouldUpdateRole, setShouldUpdateRole] = useState(false);
  const [user, setUser] = useState([]);
  const [userId, setUserId] = useState();
  const [firstDateFilter, setfirstDateFilter] = useState(moment());
  const [secondDateFilter, setsecondDateFilter] = useState(moment().add(-2, 'year'));
  const [userName, setUserName] = useState();
  const [userEmail, setUserEmail] = useState();
  const [page, setPage] = useState(1);
  const [count, setCount] = useState(0);
  const [loader, setLoader] = useState(false)

  const getUsers = (resetPage=false)=>{
    setLoader(true)
    setUser([])
    adminAxiosInstance.get(`/users/all/?user_id=${userId||''}&user_name=${userName||''}&user_email=${userEmail||''}&dateStart=${firstDateFilter}&dateEnd=${secondDateFilter}&limit=100&page=${page-1}`).then((response) => {
      if ('status' in response && response.status === 200) {
        setUser(response.data.users);
        console.log(response.data.users)
        setCount(response.data.count);
        setLoader(false)
        if(resetPage){
          setPage(1)
        }
      }
    })
    .catch(e=>{
      console.log(e);
      setLoader(false);
      setUser([])
      setCount(0)

    })
    ;
  }

  
  useMemo(() => {
    axiosInstance.get('/users').then((res) => {
      if (res.status < 210) {
        let _ = res.data;
        if (_.role && !_.role.includes('admin') ) {
          window.location.href = '/';
        }
        if(_.role && _.role === 'super_admin' || _.permissions.includes('manage_roles')){
          setShouldUpdateRole(true);
        }
        getUsers()
      }
    });
  }, [page]);

  const filterInputs = [
    {
      type:'text',
      name:'User Id',
      state:userId,
      setState:setUserId,
      function:()=>{getUsers(true)}
    },
    {
      type:'text',
      name:'User Name',
      state:userName,
      setState:setUserName,
      function:()=>{getUsers(true)}
    },
    {
      type:'text',
      name:'User Email',
      state:userEmail,
      setState:setUserEmail,
      function:()=>{getUsers(true)}
    },
    {
      type:'date',
      dateStart:firstDateFilter,
      dateEnd:secondDateFilter,
      setDateStart:setfirstDateFilter,
      setDateEnd: setsecondDateFilter,
      function:()=>{getUsers(true)}
    }
  ]

  return (
    <PageContainer title="Users Page" description="this is Users page">
      
        <>
          <Grid item xs={12} lg={8}>
          <h4>Users Details</h4>
          <AdminFilterBox inputs={filterInputs} submitFunction={getUsers}/>
          <Divider sx={{ my: 1 }} />
          {
            
          (!loader
            ?
            (
              user?.length && 
            <AdminUsersTable user={user} shouldUpdateRole={shouldUpdateRole} />
            ||
            <Stack
              justifyContent={'center'}
              alignItems={'center'}
              sx={{ width: '75vw', height: '30vh' }}>
              <Typography variant="h4" sx={{textAlign:'center'}}>No Data Found</Typography>
              </Stack>
          )
            :
            <Stack
              justifyContent={'center'}
              alignItems={'center'}
              sx={{ width: '75vw', height: '55vh' }}
            >
              <TailSpin height={45} width={45} style={{ margin: 'auto', bg: '#444' }} />
            </Stack> 
          )
         
        }
          </Grid>
          <Stack direction="row" alignItems={'center'} justifyContent={'center'}>
            <Pagination
              count={Math.ceil(count / 100)}
              onChange={(e, value) => setPage(value)}
            ></Pagination>
          </Stack>
        </>
      
    </PageContainer>
  );
};

export default AdminUsers;
